export const professorData = {
  name: "Prof. Durval Duarte Neto",
  title: "Excelência Acadêmica e Prática Jurídica",
  photo: "https://customer-assets.emergentagent.com/job_direito-hub-1/artifacts/fya6o6y8_Durval%203x4.png",
  bio: {
    summary: "Graduado em Direito e Mestre em Psicologia pela UNIVERSO. Sócio do escritório Mattos Duarte Advogados e Gestor do Curso de Direito da UNIVERSO (Campus São Gonçalo) desde 2012.",
    highlights: [
      "Professor desde 2007 e Orientador do NEPAC.",
      "Diretor Presidente da ESA (8ª Subseção).",
      "Experiência como Subprocurador de Tutela e Saúde (SG).",
      "Membro do Conselho da OAB."
    ]
  },
  story: "Uma trajetória marcada por dedicação, superação e compromisso com a excelência acadêmica e profissional no campo do Direito."
};

export const coursesData = [
  {
    id: 1,
    title: "Direito Civil Avançado",
    icon: "scale",
    description: "Aprofunde seus conhecimentos em Direito Civil com foco prático e teórico.",
    duration: "40 horas",
    level: "Avançado"
  },
  {
    id: 2,
    title: "Prática Processual",
    icon: "book",
    description: "Desenvolva habilidades práticas essenciais para atuação processual.",
    duration: "30 horas",
    level: "Intermediário"
  },
  {
    id: 3,
    title: "Direito Constitucional",
    icon: "graduation-cap",
    description: "Compreenda os fundamentos e aplicações do Direito Constitucional.",
    duration: "35 horas",
    level: "Avançado"
  }
];

export const navigationLinks = [
  { label: "Notícias da Semana", path: "/" },
  { label: "Sobre", path: "/sobre" },
  { label: "Cursos", path: "/cursos" },
  { label: "Podcast", path: "/podcast" },
  { label: "Atualizações Legislativas", path: "/atualizacoes-legislativas" },
  { label: "Entrevistas", path: "/entrevistas" },
  { label: "Bate papo do Direito", path: "/bate-papo" },
  { label: "Contato", path: "/contato" }
];

export const newsData = [
  {
    id: 1,
    title: "Nova Lei de Licitações entra em vigor",
    date: "2025-01-05",
    category: "Direito Administrativo",
    summary: "A Lei 14.133/2021 traz importantes mudanças no processo de contratação pública.",
    content: "Conteúdo completo da notícia sobre a nova lei de licitações..."
  },
  {
    id: 2,
    title: "STF julga casos importantes sobre Direito Tributário",
    date: "2025-01-04",
    category: "Direito Tributário",
    summary: "Supremo Tribunal Federal analisa questões relevantes sobre impostos e contribuições.",
    content: "Detalhes sobre os julgamentos do STF..."
  },
  {
    id: 3,
    title: "Alterações no Código de Processo Civil",
    date: "2025-01-03",
    category: "Processo Civil",
    summary: "Novas regras processuais visam acelerar tramitação de processos.",
    content: "Análise das mudanças no CPC..."
  }
];

export const podcastData = [
  {
    id: 1,
    title: "Episódio 01 - Introdução ao Direito Constitucional",
    duration: "45min",
    date: "2025-01-01",
    description: "Discussão sobre os princípios fundamentais da Constituição Federal."
  },
  {
    id: 2,
    title: "Episódio 02 - Direitos Fundamentais na Prática",
    duration: "50min",
    date: "2024-12-25",
    description: "Como os direitos fundamentais são aplicados no cotidiano jurídico."
  }
];

export const socialMedia = {
  instagram: "https://instagram.com/durvalduarteneto",
  whatsapp: "https://wa.me/5521999999999",
  facebook: "https://facebook.com/durvalduarteneto",
  email: "contato@universododireito.com.br"
};